// src/i18n/index.js
import { createI18n } from 'vue-i18n'
import EN from './en.js'
import CN from './zh.js'
import { mergeGeoContent as mergeGeoZh } from './geo/mergeZh.js'
import { mergeGeoContent as mergeGeoEn } from './geo/en-merge.js'

const cnMessages = mergeGeoZh({ ...CN })
const enMessages = mergeGeoEn({ ...EN })

function getInitialLanguage() {
  const saved = localStorage.getItem('language')
  if (saved) return saved
  const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase()
  const init = browserLang.startsWith('zh') ? 'CN' : 'EN'
  localStorage.setItem('language', init)
  return init
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLanguage(),
  fallbackLocale: 'EN',
  messages: {
    EN: enMessages,
    CN: cnMessages
  }
})

export default i18n
